import { Box, Card } from '@mui/material';
import { useColorScheme } from '@mui/material/styles';
import { useAtom } from 'jotai';
import ReactDiffViewerImport, { DiffMethod } from 'react-diff-viewer';

import type { DeviceDiffViewerProps } from '@/pages/Administration/Devices/SyncDevices/SyncDevices.types';

import { diffViewModeAtom } from '../../Devices.store';

// CommonJS interop can expose the exports object instead of its default component.
const diffViewerExport = ReactDiffViewerImport as
  | typeof ReactDiffViewerImport
  | typeof import('react-diff-viewer');
const ReactDiffViewer =
  'default' in diffViewerExport ? diffViewerExport.default : diffViewerExport;

const DeviceDiffViewer = (props: DeviceDiffViewerProps) => {
  const {
    host_name,
    device_size,
    configuration,
    prod_device_size,
    prod_configuration,
    action_type
  } = props;
  const [viewMode] = useAtom(diffViewModeAtom);
  const { mode: themeMode } = useColorScheme();

  let prodConf = {
    device_size: prod_device_size,
    configuration: prod_configuration
  };
  let devConfig = { device_size, configuration };

  const newStyles = {
    variables: {
      dark: {
        codeFoldContentColor: 'var(--mui-palette-primary-main)'
      },
      light: {
        codeFoldContentColor: '#0000ff'
      }
    }
  };

  prodConf = {
    device_size: prod_device_size || '',
    configuration: prod_configuration
      ? JSON.parse(prod_configuration)
      : prod_configuration
  };
  devConfig = {
    device_size: device_size || '',
    configuration: configuration ? JSON.parse(configuration) : configuration
  };

  let oldJson = '';
  let newJson = '';
  if (action_type === 'New') {
    newJson = JSON.stringify(devConfig, null, 2);
    oldJson = '';
  } else if (action_type === 'Deleted') {
    oldJson = JSON.stringify(prodConf, null, 2);
    newJson = '';
  } else {
    oldJson = JSON.stringify(prodConf, null, 2);
    newJson = JSON.stringify(devConfig, null, 2);
  }

  return (
    <Box>
      <Card className="customReactDiffViewer" style={{ boxShadow: 'none' }}>
        <ReactDiffViewer
          key={`diff-viewer-${host_name}`}
          oldValue={oldJson}
          newValue={newJson}
          splitView={viewMode === 'split'}
          showDiffOnly
          useDarkTheme={themeMode === 'dark'}
          compareMethod={DiffMethod.WORDS}
          styles={newStyles}
        />
      </Card>
    </Box>
  );
};

export default DeviceDiffViewer;
